import "./WedgeWireScreen.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import CtaBand from "@/components/common/CtaBand";
import useHashScroll from "@/hooks/useHashScroll";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
import { COMMON } from "@/lib/commonCopy";
import WedgeHero from "./sections/WedgeHero";
import StructureDiagram from "./sections/StructureDiagram";
import Overview from "./sections/Overview";
import WedgeWire from "./sections/WedgeWire";

// Sibling coder group files (default exports, no props)
import FlatPanelGroup from "./sections/FlatPanelGroup";
import CurvedGroup from "./sections/CurvedGroup";
import CylindricalGroup from "./sections/CylindricalGroup";
import ScreenTubesGroup from "./sections/ScreenTubesGroup";
import NozzlesGroup from "./sections/NozzlesGroup";
import SieveBendGroup from "./sections/SieveBendGroup";
import Manufacturing from "./sections/Manufacturing";
import RelatedArticles from "@/components/common/RelatedArticles";
interface ClosingCtaCopy {
  eyebrow: string;
  heading: string;
  lead: string;
  secondaryLabel: string;
}
const closingCtaData: Record<Lang, ClosingCtaCopy> = {
  en: {
    eyebrow: "Wedge Wire Screens",
    heading: "Request a Technical Quote for Precision Wedge Wire Screens",
    lead: "From custom cylindrical screens and flat sieve panels to complex reactor internals and filter candles, our engineering team supplies tailored wedge wire assemblies with precision slot tolerances and material traceability.",
    secondaryLabel: "Contact Our Engineers"
  },
  zh: {
    eyebrow: "约翰逊楔形滤网",
    heading: "获取约翰逊楔形滤网技术报价与工程方案",
    lead: "从定制圆筒滤网和平板筛板到复杂的反应器内件与烛式滤芯，我们的工程团队提供具备精密缝隙公差和完整材质可追溯性的定制楔形滤网组件。",
    secondaryLabel: "联系工程团队"
  },
  es: {
    eyebrow: "Rejillas de alambre de cuña",
    heading: "Solicite presupuesto técnico de rejilla de cuña",
    lead: "Desde cilindros filtrantes y paneles planos hasta componentes de reactores, suministramos conjuntos de alambre de cuña con tolerancias precisas de ranura y trazabilidad de materiales.",
    secondaryLabel: "Contactar con ingenieros"
  },
  de: {
    eyebrow: "Spaltsiebe & Keildrahtfilter",
    heading: "Technisches Angebot für Spaltsiebe anfragen",
    lead: "Von maßgefertigten Spaltsiebrohren und Flachsieben bis zu Reaktoreinbauten: Unser Engineering-Team liefert präzise gefertigte Spaltsiebkomponenten mit engen Spaltweitentoleranzen und Materialrückverfolgbarkeit.",
    secondaryLabel: "Ingenieure kontaktieren"
  },
  fr: {
    eyebrow: "Grilles à fil triangulaire (Wedge Wire)",
    heading: "Demandez un devis technique pour grilles à fil de coin",
    lead: "Des cylindres filtrants sur mesure aux panneaux plats et éléments internes de réacteurs, nous fabriquons des ensembles en fil triangulaire avec fentes de précision et traçabilité des matériaux.",
    secondaryLabel: "Contacter un ingénieur"
  },
  pt: {
    eyebrow: "Telas de arame cunha (Wedge Wire)",
    heading: "Solicite um orçamento técnico de telas de arame cunha",
    lead: "De cilindros filtrantes sob medida a painéis planos e internos de reatores, fornecemos conjuntos de arame cunha com tolerâncias precisas de abertura e rastreabilidade de materiais.",
    secondaryLabel: "Fale com engenheiros"
  }
};
export default function WedgeWireScreenPage() {
  useHashScroll();
  const {
    lang
  } = useLanguage();
  const c = pick(lang, closingCtaData);
  return <div>
      <Header />
      <PageBreadcrumb page="WedgeWireScreen" />
      <WedgeHero />
      <StructureDiagram />
      <Overview />
      <WedgeWire />
      <FlatPanelGroup />
      <CurvedGroup />
      <CylindricalGroup />
      <ScreenTubesGroup />
      <NozzlesGroup />
      <SieveBendGroup />
      <Manufacturing />
      <RelatedArticles topic="wedge" />
      <CtaBand id="wedge-wire-closing-cta" eyebrow={c.eyebrow} heading={c.heading} lead={c.lead} primary={{
      label: pick(lang, COMMON.requestQuote),
      to: "/RequestAQuotePage"
    }} secondary={{
      label: c.secondaryLabel,
      to: "/ContactPage"
    }} />
      <Footer />
    </div>;
}